module.exports = __webpack_public_path__ + "static/media/archive-icon.a7dafe71.svg";